import { computed, ref } from 'vue'
import { eventQueueNoticeOpen } from '@shared/index'
import { useSiteStore } from '../stores/site'
import { localDayKey } from '../utils/localDay'

const SNOOZE_KEY = 'dc.eventQueue.notice.snooze'

function readStorage(storage: Storage, key: string): string | null {
  try {
    return storage.getItem(key)
  } catch {
    return null
  }
}

function writeStorage(storage: Storage, key: string, value: string): void {
  try {
    storage.setItem(key, value)
  } catch {
    /* private mode */
  }
}

function parseSnooze(raw: string | null): { day: string; id: string } | null {
  if (!raw) return null
  const sep = raw.indexOf('|')
  if (sep <= 0) return null
  return { day: raw.slice(0, sep), id: raw.slice(sep + 1) }
}

if (import.meta.env.DEV && typeof localStorage !== 'undefined') {
  try {
    localStorage.removeItem(SNOOZE_KEY)
  } catch {
    /* private mode */
  }
}

const snooze = ref<{ day: string; id: string } | null>(
  import.meta.env.DEV || typeof localStorage === 'undefined'
    ? null
    : parseSnooze(readStorage(localStorage, SNOOZE_KEY)),
)

/** Home explainer. Hidden after the first 3 days, or after today's snooze. */
export function useEventQueueNotice() {
  const site = useSiteStore()
  const offerDialog = computed(() => {
    const live = site.eventQueue
    if (!live || !eventQueueNoticeOpen(live)) return false
    const held = snooze.value
    return !(held && held.day === localDayKey() && held.id === live.endsAt)
  })

  function snoozeToday(): void {
    const live = site.eventQueue
    if (!live) return
    const next = { day: localDayKey(), id: live.endsAt }
    snooze.value = next
    writeStorage(localStorage, SNOOZE_KEY, `${next.day}|${next.id}`)
  }

  return { offerDialog, snoozeToday }
}
